import React from 'react'
import { Formik } from "formik";
import * as Yup from 'yup';

const SchemaSorteos = Yup.object({
    tipo: Yup.string().required('Seleccione un tipo de reporte.')
});
export default function ReporteFinal(props) {
    const { Sorteo, N1, N2 } = props;
    return (
        <Formik
            initialValues={{
                tipo: '',
            }}
            validationSchema={SchemaSorteos}
            enableReinitialize="true"
            onSubmit={(values, actions) => {
                //https://api.ticc.com.mx/api/
                //http://localhost/qa.lumen/api
                var redirectWindow = window.open(`${process.env.URLAPI}getReporteFinal/${Sorteo}/${values.tipo}/${N1}/${N2!=''?N2:null}`, '_blank');
                redirectWindow.location;
                //alert("pass");
                //Save(values, actions);
            }}>
            {({
                values,
                errors,
                status,
                setFieldValue,
                handleBlur,
                handleChange,
                handleSubmit,
                resetForm
            }) => <div className="modal" id="reporte" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                    <div className="modal-dialog modal-sm" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Generar reporte final</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <form onSubmit={handleSubmit} >
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-sm-12 col-md-12 col-lg-12">
                                            <div className={errors.tipo ? "form-check has-error" : "form-check"}>
                                                <input className="form-check-input" type="radio" name="tipo" id="tipo" value="1" onChange={handleChange} />
                                                <label className="form-check-label" >
                                                    Agrupado
                                                </label>
                                            </div>
                                            <div  className={errors.tipo ? "form-check has-error" : "form-check"}>
                                                <input className="form-check-input" type="radio" name="tipo" onChange={handleChange} id="tipo" value="2" />
                                                <label className="form-check-label" >
                                                   Desglozado
                                                </label>
                                            </div>
                                            <span className="help-block">{errors.tipo}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => () => resetForm()} >Cancelar</button>
                                    <button type='submit' className={`btn btn-primary`}>Generar</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            }
        </Formik>
    )
}
